// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8rzgW","icon":"styles_icon__1QyLN"};